import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'uppercase' })
export class UpperCaseString implements PipeTransform {
    constructor() {}
    transform(value: string): string {
        let newStr: string = '';
        let finalString: string = '';
        if (value) {
            for (var i = 0; i < value.length; i++) {
                if (value.charAt(i) === '_') {
                    newStr += ' ';
                } else {
                    newStr += value.charAt(i);
                }
            }
            return newStr.toUpperCase().trim();
            
        }
        return '';
    }
}
